module.exports = __webpack_public_path__ + "media/images/countryrect/fi-29548b17c99936b3f1c52b2611766dbf.svg";